exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-toggle{\r\n    cursor: pointer;\r\n}\r\n.logout-pointer{\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/bs-navbar/bs-navbar.component.css
// module id = ../../../../../src/app/bs-navbar/bs-navbar.component.css
// module chunks = main